// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4324":"24c29d69","4480":"44d8cc3e","6252":"980c875b","7333":"cbbd38f3","8240":"44d8cc3e","8664":"da8d9d89","9476":"ccddeab5"}[chunkId] + ".chunk.css";
};